export const PALETTE_DEVICE_BY_ENV = {
    boozt: 'desktop',
    booztmobile: 'mobile',
    webshop: 'desktop',
    webshopmobile: 'mobile'
};

export const STORE_NAME = 'store';
